module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_null_null@3x.bdf8d3d4.png";